module.exports = __webpack_public_path__ + "img/radhaprasad-profile.558bf0e.jpg";